﻿import React from 'react';

import { getEpiData } from '../../../Utils/epiHelpers';

//animation components
import TopCarBgAnimation from './Animations/TopCarBgAnimation';
import HeartAnimation from './Animations/HeartAnimation';
import CheckmarkContainer from './Animations/CheckmarkContainer';
import RatingContainer from './Animations/CheckmarkContainer';
import ElectricCarAnimation from './Animations/ElectricCarAnimation';
import MultiCarAnimation from './Animations/MultiCarAnimation';
import HomeAnimation from './Animations/HomeAnimation';
import EnvLogoAnimation from './Animations/EnvLogoAnimation';
import FooterBgAnimation from './Animations/FooterBgAnimation';
import RatingAnimation from './Animations/RatingAnimation';

//text components
import HeartText from './Texts/HeartText';
import HomeText from './Texts/HomeText';
import ElectricText from './Texts/ElectricText';
import MultiText from './Texts/MultiText';
import EnvLogoText from './Texts/EnvLogoText';
import RatingText from './Texts/RatingText';


const CarInsuranceCampaignPage = (props) => {

    const heading1 = getEpiData('heading-1', props.mountRootId) || '';
    const subtext1 = getEpiData('subtext-1', props.mountRootId) || '';
    const heading2 = getEpiData('heading-2', props.mountRootId) || '';
    const subtext2 = getEpiData('subtext-2', props.mountRootId) || '';
    const heading3 = getEpiData('heading-3', props.mountRootId) || '';
    const subtext3 = getEpiData('subtext-3', props.mountRootId) || '';
    const heading4 = getEpiData('heading-4', props.mountRootId) || '';
    const subtext4 = getEpiData('subtext-4', props.mountRootId) || '';
    const heading5 = getEpiData('heading-5', props.mountRootId) || '';
    const subtext5 = getEpiData('subtext-5', props.mountRootId) || '';
    const heading6 = getEpiData('heading-6', props.mountRootId) || '';
    const subtext6 = getEpiData('subtext-6', props.mountRootId) || '';
    const uspheading1 = getEpiData('usp-heading-1', props.mountRootId) || '';
    const uspsubtext1 = getEpiData('usp-subtext-1', props.mountRootId) || '';
    const uspheading2 = getEpiData('usp-heading-2', props.mountRootId) || '';
    const uspsubtext2 = getEpiData('usp-subtext-2', props.mountRootId) || '';
    const uspheading3 = getEpiData('usp-heading-3', props.mountRootId) || '';
    const uspsubtext3 = getEpiData('usp-subtext-3', props.mountRootId) || '';
    const buttonText1 = getEpiData('buttontext-1', props.mountRootId) || '';
    const buttonLink1 = getEpiData('buttonlink-1', props.mountRootId) || '';
    const buttonText2 = getEpiData('buttontext-2', props.mountRootId) || '';
    const buttonLink2 = getEpiData('buttonlink-2', props.mountRootId) || '';
    const buttonText3 = getEpiData('buttontext-3', props.mountRootId) || '';
    const buttonLink3 = getEpiData('buttonlink-3', props.mountRootId) || '';
    const finePrint = getEpiData('smallprint', props.mountRootId) || '';
    const ratingText = getEpiData('rating', props.mountRootId) || '';
    const envText = getEpiData('environment', props.mountRootId) || '';

    const headings = [uspheading1, uspheading2, uspheading3];
    const texts = [uspsubtext1, uspsubtext2, uspsubtext3];

    return (
        <div className="car-insurance-campaign">

            <TopCarBgAnimation heading={heading1} text={subtext1} buttonLink={buttonLink1} buttonText={buttonText1} />

             <section className="car-insurance-campaign__section car-insurance-campaign__usp">
                <CheckmarkContainer headings={headings} texts={texts} />
            </section>

            <section className="car-insurance-campaign__section car-insurance-campaign__section--stacked car-insurance-campaign__rating">
                <div className="col-1-2">
                    <RatingAnimation />
                    <RatingText text={ratingText} />
                </div>
            </section>

            <section className="car-insurance-campaign__section car-insurance-campaign__home">
                <HomeAnimation />
                <HomeText heading={heading2} text={subtext2} />
            </section>

            <section className="car-insurance-campaign__section car-insurance-campaign__electric-car">
                <ElectricText heading={heading3} text={subtext3} buttonLink={buttonLink2} buttonText={buttonText2}/>
                <ElectricCarAnimation />
            </section>

            <section className="car-insurance-campaign__section car-insurance-campaign__multi-car">
                <MultiCarAnimation />               
                <MultiText heading={heading4} text={subtext4} />
            </section>

            <section className="car-insurance-campaign__section car-insurance-campaign__heart">              
                <HeartText heading={heading5} text={subtext5} />
                <HeartAnimation />
            </section>

            <section className="car-insurance-campaign__section car-insurance-campaign__section--stacked car-insurance-campaign__env-logo">
                <div className="">
                    <EnvLogoAnimation />
                    <EnvLogoText text={envText} />
                </div>
            </section>

            <FooterBgAnimation heading={heading6} text={subtext6} buttonLink={buttonLink3} buttonText={buttonText3} finePrint={finePrint} />

        </div>
        )
   }
              
export default CarInsuranceCampaignPage;


